var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
var HideablePassword = function (_a) {
    var _b = _a.name, name = _b === void 0 ? "password" : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "Enter password" : _c, _d = _a.title, title = _d === void 0 ? "Must contain at least one number, one uppercase and lowercase letter, and at least 8 characters" : _d, _e = _a.label, label = _e === void 0 ? "Password" : _e, _f = _a.autoComplete, autoComplete = _f === void 0 ? "off" : _f, rest = __rest(_a, ["name", "placeholder", "title", "label", "autoComplete"]);
    var _g = useState("password"), inputType = _g[0], setInputType = _g[1];
    var icon = inputType === "password" ? "eye" : "eye-slash";
    var onHideToggle = function () {
        return void setInputType(function (type) { return (type === "password" ? "text" : "password"); });
    };
    return (_jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: name, className: "font-bold", children: label }), _jsxs("div", { className: "relative", children: [_jsx("input", __assign({ id: name, type: inputType, placeholder: placeholder, name: name, required: true, title: title, autoComplete: autoComplete }, rest)), _jsx(FontAwesomeIcon, { icon: icon, onClick: onHideToggle, className: "absolute right-1 top-3 transform cursor-pointer text-gray-500" })] })] }));
};
export default HideablePassword;
export var defaultPasswordPattern = "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}";
